export default {
    units_import_title: 'Importar Unidades',
    units_import_button: 'Importar',
    units_import_cancel: 'Cancelar',
    units_comma: 'Coma (,)',
    units_semicolon: 'Punto y coma (;)',
    units_selectDelimiter: 'Seleccionar',
    units_delimiter: 'Delimitador',
    units_error_delimiter: 'Se requiere delimitador',
    units_import_instructions: 'Nota importante: La columna ID es obligatoria. Esta función de importación solo está destinada a actualizar registros existentes, realice una exportación de la tabla sin editar el valor de la columna ID para mantener la referencia del registro. Por favor, agregue "km" o "mi" al final de los valores del odómetro para especificar la unidad de medida; Si no se especifica ninguna unidad, los datos se almacenarán en millas.',
    units_download_template: 'Descargar Plantilla',
    units_template_unitColumn: 'Unidad',
    units_template_vinColumn: 'VIN',
    units_template_yearColumn: 'Año',
    units_template_makeColumn: 'Marca',
    units_template_modelColumn: 'Modelo',
    units_template_tagsColumn: 'Etiquetas',
    units_template_driverColumn: 'Conductor',
    units_template_defaultDriverColumn: 'Conductor Predeterminado',
    units_template_engineHoursColumn: 'Horas de Motor',
    units_template_odometerColumn: 'Odómetro',
    units_template_inspection_device_typeColumn: 'Tipo de Dispositivo de Inspección',
    units_template_inspection_tag_idColumn: 'ID de Etiqueta de Inspección',
    units_template_power_unit_numberColumn: 'Número de Unidad de Potencia',
    units_template_maintenance_companyColumn: 'Compañía de Mantenimiento',
    units_template_registration_countryColumn: 'País de Registro',
    units_template_registration_stateColumn: 'Estado de Registro',
    units_template_registration_expiration_dateColumn: 'Fecha de Expiración de Registro',
    units_template_engine_serial_numberColumn: 'Número de Serie del Motor',
    units_template_license_plateColumn: 'Matrícula',
    units_template_asset_typeColumn: 'Tipo de Activo',
    units_template_asset_subtypeColumn: 'Subtipo de Activo',

    units_import_error_CU01: 'Archivo CSV vacío: El archivo no contiene filas de datos. Por favor, agregue al menos una fila con información de la unidad.',
    units_import_error_CU02: 'Error en el formato CSV: La columna ID es obligatoria para las actualizaciones de unidades.',
    units_import_error_CU03: 'No se encontraron filas de datos válidas: Las columnas ID y Label no pueden estar vacías en todas las filas.',
};